'use client'

import { createContext, useContext, type ReactNode } from 'react'

import { dictionaryFor, type Dictionary } from '@/lib/i18n/dictionary'

const DictionaryContext = createContext<Dictionary>(dictionaryFor('mn'))

/**
 * Клиент бүрэлдэхүүнд толь хүргэнэ.
 *
 * `getLocale()` нь `cookies()` уншдаг тул зөвхөн серверт ажиллана — иймд
 * layout дээр нэг удаа уншиж, доошоо контекстээр дамжуулна.
 */
export const DictionaryProvider = ({ value, children }: { value: Dictionary; children: ReactNode }) => (
  <DictionaryContext.Provider value={value}>{children}</DictionaryContext.Provider>
)

export const useDictionary = (): Dictionary => useContext(DictionaryContext)
